import { useBackend } from "../../services";

export const useIncrementCollectionVisits = () => {
  const { post } = useBackend();
  const incrementCollectionVisits = (collectionId: string) =>
    post("collections/visits", { collectionId });
  return { incrementCollectionVisits };
};
